module.exports = __webpack_public_path__ + "img/icon-safari.990b41b5.svg";